import { Injectable } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http'
//import{ GlobalConstants } from '../../common/global-constants';
import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  //readonly BaseURI = GlobalConstants.apiURL;// "https://localhost:44346/api";
  BaseURI : string;
  formModel = this.fb.group({
    Passwords: this.fb.group({
      Password: ['', [Validators.required, Validators.minLength(4)]],
      ConfirmPassword: ['', Validators.required]
    }, {validator : this.comparePasswords})
  });


  formPasswordModel = this.fb.group({
    Passwords: this.fb.group({
      OldPassword : ['', [Validators.required, Validators.minLength(4)]],
      NewPassword: ['', [Validators.required, Validators.minLength(4)]],
      ConfirmPassword: ['', Validators.required]
    }, {validator : this.compareChangePasswords})
  });

  form  = UserModel.getFormGroup();

  constructor(private fb: FormBuilder, private http: HttpClient) {
    this.BaseURI = window.location.origin + "/api";
    console.log ("UserService :" + this.BaseURI);
   }


  populateForm(item) {
     this.form.setValue(item);
  }

   initializeFormGroup(){
      UserModel.initializeFormGroup(this.form);
   }

  comparePasswords(fb:FormGroup) {
    let confirmPasswordCtrl = fb.get("ConfirmPassword");
    //passwordMismatch
    //confirmPasswordCtrl.errors = {passwordMismatch:true}
    if (confirmPasswordCtrl.errors == null || "passwordMismatch" in confirmPasswordCtrl.errors) {
      if (fb.get("Password").value != confirmPasswordCtrl.value) {
        confirmPasswordCtrl.setErrors({ passwordMismatch: true });
      }
      else {
        confirmPasswordCtrl.setErrors(null);
      }
    }
  }

  compareChangePasswords(fb:FormGroup) {

    let passwordCtrl = fb.get("NewPassword");

    if (passwordCtrl.errors == null) {
      if (fb.get("OldPassword").value == passwordCtrl.value) {
        passwordCtrl.setErrors({passwordMismatch:true });
      }
      else {
        passwordCtrl.setErrors(null);
      }
    }

    let confirmPasswordCtrl = fb.get("ConfirmPassword");
    //passwordMismatch
    //confirmPasswordCtrl.errors = {passwordMismatch:true}

    if (confirmPasswordCtrl.errors == null || "passwordMismatch" in confirmPasswordCtrl.errors) {
      if (passwordCtrl.value != confirmPasswordCtrl.value) {
        confirmPasswordCtrl.setErrors({ passwordMismatch: true });
      }
      else {
        confirmPasswordCtrl.setErrors(null);
      }
    }

  }

  register() {
    let body = {
      UserName: this.form.value.userName,
      Email: this.form.value.email,
      FullName: this.form.value.fullName,
      PhoneNumber : this.form.value.phoneNumber,
      Role: this.form.value.role,
      CountryCode : this.form.value.countryCode,
      Password: this.formModel.value.Passwords.Password,

    };

    return this.http.post(this.BaseURI + "/ApplicationUser/Register", body);
  }

  changePassword() {
    let body = {
      Id: this.getUserID(),
      Password: this.formPasswordModel.value.Passwords.OldPassword,
      NewPassword: this.formPasswordModel.value.Passwords.NewPassword,
    };

    return this.http.post(this.BaseURI + "/ApplicationUser/ChangePassword", body);
  }


  login(formData)  {
    return this.http.post(this.BaseURI + "/ApplicationUser/Login", formData);
  }

   updateData(item : UserModel) {
   // return this.http.put(this.BaseURI + "/ApplicationUser/Update/" + item.id, item);
     return this.http.put(this.BaseURI + "/ApplicationUser/" + item.id, item);
  }

  deleteData(id)
  {
    return this.http.delete(this.BaseURI + "/ApplicationUser/" + id);

  }


  updateProfile(item : UserModel) {
    return this.http.put(this.BaseURI + "/UserProfile", item);
  }

  getUserProfile(){
    return this.http.get(this.BaseURI + "/UserProfile");
  }

  getUserList()
  {
    return this.http.get(this.BaseURI + "/UserProfile/UserList");
  }


  requestResetPassword(item)
  {
    return this.http.get(this.BaseURI + "/ApplicationUser/RequestResetPassword?username=" + item);
  }


  resetPassword(item)
  {
    return this.http.post(this.BaseURI + "/ApplicationUser/ResetPassword", item);
  }

  roleMatch(allowedRoles):boolean{
    var isMatch = false;
    var payLoad = JSON.parse(window.atob(localStorage.getItem("token").split(".")[1]));
   // console.log(" playLoad : " + payLoad);
    var userRole = payLoad.role;
    allowedRoles.forEach(element => {
      if(userRole == element){
        isMatch = true;
        return true;
      }
    });

    return isMatch

  }

  getUserID():string{
   // var isMatch = false;
    var payLoad = JSON.parse(window.atob(localStorage.getItem("token").split(".")[1]));
    return payLoad.UserID;

  }

  getCountryCode():string{
    //var isMatch = false;
    var payLoad = JSON.parse(window.atob(localStorage.getItem("token").split(".")[1]));
    return payLoad.Country;

  }

  isMasterRole()
  {
    return this.roleMatch(['Master']);
  }

  isAdminRole()
  {
    return this.roleMatch(['Admin', 'Master']);
  }

  isSameUser(userid)
  {
    return (this.getUserID() == userid);
  }
}
